import * as React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import { Grid } from '@mui/material'

import useStyles from './useStyles'
import CloseIcon from '@mui/icons-material/Close'

export default function StepFileDetails ({ setstateSeeMore, item }) {
  const classes = useStyles()

  const formatDate = (date) => {
    let formattedDate
    if (date) {
      const newDate = new Date(date)
      formattedDate =
        newDate.getDate() +
        '/' +
        (newDate.getMonth() + 1) +
        '/' +
        newDate.getFullYear()
    } else {
      formattedDate = '- -'
    }
    return formattedDate
  }

  const FileDetails = ({ item }) => {
    return (
      <>
        <Grid container className={classes.container}>
          <Grid
            item
            xs={5}
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Typography className={classes.key}>Nombre:</Typography>
          </Grid>
          <Grid
            item
            xs={7}
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Typography className={classes.value}>
              {item.name || '- -'}
            </Typography>
          </Grid>
        </Grid>
        <Grid container className={classes.container}>
          <Grid
            item
            xs={5}
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Typography className={classes.key}>Tipo de documento:</Typography>
          </Grid>
          <Grid
            item
            xs={7}
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Typography className={classes.value}>
              {item.documentType}
            </Typography>
          </Grid>
        </Grid>
        <Grid container className={classes.container}>
          <Grid
            item
            xs={5}
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Typography className={classes.key}>Tamaño:</Typography>
          </Grid>
          <Grid
            item
            xs={7}
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Typography className={classes.value}>{item.size}</Typography>
          </Grid>
        </Grid>
        <Grid container className={classes.container}>
          <Grid
            item
            xs={5}
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Typography className={classes.key}>Fecha de creación:</Typography>
          </Grid>
          <Grid
            item
            xs={7}
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Typography className={classes.value}>
              {formatDate(item.audit?.creationDate)}
            </Typography>
          </Grid>
        </Grid>
        <Grid container className={classes.container}>
          <Grid
            item
            xs={5}
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Typography className={classes.key}>Creado por:</Typography>
          </Grid>
          <Grid
            item
            xs={7}
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Typography className={classes.value}>
              {item.audit?.creationUser}
            </Typography>
          </Grid>
        </Grid>
        <Grid container className={classes.container}>
          <Grid
            item
            xs={5}
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Typography className={classes.key}>
              Fecha de eliminación:
            </Typography>
          </Grid>
          <Grid
            item
            xs={7}
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Typography className={classes.value}>
              {formatDate(item.purgeDate)}
            </Typography>
          </Grid>
        </Grid>
        <Grid container className={classes.container}>
          <Grid
            item
            xs={5}
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Typography className={classes.key}>Eliminado por:</Typography>
          </Grid>
          <Grid
            item
            xs={7}
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Typography className={classes.value}>
              {item.purgeActionUser}
            </Typography>
          </Grid>
        </Grid>
        <Grid container className={classes.container}>
          <Grid
            item
            xs={5}
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Typography className={classes.key}>Ruta:</Typography>
          </Grid>
          <Grid
            item
            xs={7}
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Typography className={classes.value}>
              {item.absolutePath}
            </Typography>
          </Grid>
        </Grid>
      </>
    )
  }

  return (
    <>
      <Box className={classes.backgroundBox}>
        <div
          style={{
            width: '100%',
            display: 'flex',
            padding: '8px 0px 8px 0px',
            justifyContent: 'space-between',
            boxShadow: '0px 1px 1px #EAEAEA',
            color: '#8C8C8C'
          }}
        >
          <Typography className={classes.seeMoreTypography}>
            Información del documento
          </Typography>
          <CloseIcon
            style={{
              cursor: 'pointer',
              paddingRight: 10,
              fontSize: '1.5rem'
            }}
            onClick={() => {
              setstateSeeMore(false)
            }}
          />
        </div>

        <div className={classes.mainBox}>
          <FileDetails item={item} />
        </div>
        <ButtonClose setstateSeeMore={setstateSeeMore} />
      </Box>
    </>
  )
}

function ButtonClose ({ setstateSeeMore }) {
  const classes = useStyles()

  return (
    <Box className={classes.closeButton}>
      <Box
        className={classes.closeButtonStyle}
        sx={{
          '&:hover': {
            bgcolor: '#1BF57F'
          }
        }}
        onClick={() => {
          setstateSeeMore(false)
        }}
      >
        <Typography className={classes.closeButtonTypography}>
          Cerrar
        </Typography>
      </Box>
    </Box>
  )
}
